var _clipPath;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWupLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 354.33124 62.100751",
    height: "100%",
    width: "100%",
    xmlSpace: "preserve",
    id: "svg3355",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath3369",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3371",
    d: "m 0,113.386 425.197,0 L 425.197,0 0,0 0,113.386 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.25,0,0,-1.25,-88.582625,101.91688)",
    id: "g3363"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(186.3332,55.791)",
    id: "g3373"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3375",
    style: {
      fill: "#433965",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 -3.716,0 c -0.101,0 -0.168,-0.066 -0.168,-0.168 l 0,-9.477 c 0,-2.01 -1.072,-3.949 -3.684,-3.949 -2.646,0 -3.718,2.277 -3.718,4.285 l 0,9.141 c 0,0.102 -0.066,0.168 -0.166,0.168 l -3.685,0 c -0.099,0 -0.165,-0.066 -0.165,-0.168 l 0,-9.141 c 0,-4.219 1.807,-7.97 7.398,-7.97 1.408,0 2.948,0.836 3.652,1.573 0.133,0.168 0.3,0.102 0.368,-0.033 l 0.334,-1.004 c 0.068,-0.135 0.134,-0.201 0.337,-0.201 l 3.18,0 c 0.099,0 0.168,0.066 0.168,0.168 l 0,16.608 C 0.135,-0.066 0.066,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(290.2546,56.1261)",
    id: "g3377"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3379",
    style: {
      fill: "#433965",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 -1.406,0 c -3.115,0 -4.454,-1.876 -4.889,-2.412 -0.102,-0.134 -0.302,-0.134 -0.336,0.069 l -0.335,1.84 c -0.033,0.099 -0.066,0.168 -0.166,0.168 l -1.674,0 c -0.102,0 -0.168,-0.069 -0.168,-0.168 l 0,-16.608 c 0,-0.102 0.066,-0.168 0.168,-0.168 l 2.008,0 c 0.099,0 0.167,0.066 0.167,0.168 l 0,8.94 c 0,3.952 1.474,5.828 5.225,5.828 l 1.406,0 c 0.101,0 0.168,0.066 0.168,0.167 l 0,2.008 C 0.168,-0.066 0.101,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(249.1707,40.5209)",
    id: "g3381"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3383",
    style: {
      fill: "#433965",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -3.751,0 -5.626,2.78 -5.626,6.798 0,4.018 1.875,6.798 5.626,6.798 3.751,0 5.96,-2.78 5.96,-6.798 C 5.96,2.78 3.751,0 0,0 m 0.335,15.667 c -3.786,0 -5.425,-2.041 -5.659,-2.376 -0.102,-0.168 -0.269,-0.102 -0.302,0.033 l -0.336,1.842 c -0.033,0.1 -0.066,0.168 -0.168,0.168 l -1.672,0 c -0.102,0 -0.168,-0.068 -0.168,-0.168 l 0,-23.667 c 0,-0.101 0.066,-0.167 0.168,-0.167 l 2.008,0 c 0.101,0 0.168,0.066 0.168,0.167 l 0,8.965 c 0,0.135 0.2,0.201 0.302,0.033 0.3,-0.434 1.941,-2.442 5.659,-2.442 5.056,0 7.97,3.581 7.97,8.806 0,5.225 -2.747,8.806 -7.97,8.806"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(338.9425,48.4576)",
    id: "g3385"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3387",
    style: {
      fill: "#433965",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 -10.75,0 c -0.099,0 -0.168,0.066 -0.168,0.166 0,2.01 1.776,5.527 5.594,5.527 3.916,0 5.492,-3.116 5.492,-5.527 C 0.168,0.066 0.101,0 0,0 m -5.324,7.701 c -5.022,0 -8.138,-3.582 -8.138,-8.84 0,-5.224 3.281,-8.808 8.138,-8.808 3.616,0 6.463,1.575 7.467,4.623 0.033,0.134 -0.1,0.165 -0.201,0.165 l -2.143,0 c -0.101,0 -0.201,-0.031 -0.267,-0.165 -0.637,-1.24 -2.144,-2.613 -4.856,-2.613 -3.517,0 -5.594,2.847 -5.594,5.761 0,0.1 0.069,0.166 0.168,0.166 l 13.195,0 c 0.099,0 0.167,0.068 0.201,0.168 0.033,0.101 0.066,0.468 0.066,0.703 0,5.223 -3.014,8.84 -8.036,8.84"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(273.2708,45.7118)",
    id: "g3389"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3391",
    style: {
      fill: "#433965",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -0.066,-2.345 -1.807,-5.19 -6.196,-5.19 -3.213,0 -4.486,1.607 -4.486,3.147 0,1.474 0.702,3.014 4.954,3.014 l 5.56,0 C -0.066,0.971 0,0.903 0,0.803 L 0,0 Z m 4.554,-4.856 -0.368,0 c -1.406,0 -1.843,0.503 -1.843,2.244 l 0,6.999 c 0,4.018 -2.879,6.028 -7.467,6.028 -4.018,0 -7.232,-1.977 -7.232,-6.062 0,-0.101 0.066,-0.167 0.167,-0.167 l 2.008,0 c 0.102,0 0.168,0.066 0.168,0.167 0,2.646 1.54,4.052 4.889,4.052 C -0.402,8.405 0,6.128 0,4.387 0,2.981 -0.602,2.981 -1.675,2.981 l -4.185,0 c -4.756,0 -7.096,-1.944 -7.096,-5.024 0,-3.047 2.34,-5.157 6.76,-5.157 4.153,0.102 5.759,1.909 6.262,2.41 0.102,0.101 0.234,0.101 0.302,-0.066 0.57,-1.373 1.507,-2.008 3.818,-2.008 l 0.368,0 c 0.1,0 0.168,0.066 0.168,0.165 l 0,1.675 c 0,0.101 -0.068,0.168 -0.168,0.168"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(314.4863,56.1261)",
    id: "g3393"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3395",
    style: {
      fill: "#433965",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -2.948,0 -4.755,-1.774 -5.225,-2.412 -0.099,-0.134 -0.3,-0.134 -0.333,0.069 l -0.336,1.84 c -0.033,0.135 -0.099,0.168 -0.2,0.168 l -1.642,0 c -0.099,0 -0.168,-0.069 -0.168,-0.168 l 0,-16.608 c 0,-0.102 0.069,-0.168 0.168,-0.168 l 2.01,0 c 0.101,0 0.168,0.066 0.168,0.168 l 0,8.94 c 0,4.018 1.474,6.161 5.223,6.161 C 3.55,-2.043 4.89,-4.89 4.89,-8.171 l 0,-8.94 c 0,-0.102 0.066,-0.168 0.167,-0.168 l 2.01,0 c 0.1,0 0.166,0.066 0.166,0.168 l 0,8.94 C 7.233,-3.215 5.123,-0.033 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(354.1631,56.1261)",
    id: "g3397"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3399",
    style: {
      fill: "#433965",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 -1.406,0 c -3.115,0 -4.454,-1.876 -4.889,-2.412 -0.102,-0.134 -0.302,-0.134 -0.336,0.069 l -0.333,1.84 c -0.035,0.099 -0.068,0.168 -0.168,0.168 l -1.674,0 c -0.102,0 -0.168,-0.069 -0.168,-0.168 l 0,-16.608 c 0,-0.102 0.066,-0.168 0.168,-0.168 l 2.008,0 c 0.101,0 0.167,0.066 0.167,0.168 l 0,8.94 c 0,3.952 1.474,5.828 5.225,5.828 l 1.406,0 c 0.101,0 0.168,0.066 0.168,0.167 l 0,2.008 C 0.168,-0.066 0.101,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(302.8825,55.9072)",
    id: "g3401"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3403",
    style: {
      fill: "#433965",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 -3.85,0 c -0.102,0 -0.168,0.066 -0.168,0.168 l 0,3.93 c 0,0.099 -0.066,0.168 -0.168,0.168 l -2.01,0 c -0.099,0 -0.165,-0.069 -0.165,-0.168 l 0,-3.93 C -6.361,0.066 -6.43,0 -6.529,0 l -3.182,0 c -0.101,0 -0.168,-0.066 -0.168,-0.168 l 0,-1.674 c 0,-0.1 0.067,-0.168 0.168,-0.168 l 3.182,0 c 0.099,0 0.168,-0.066 0.168,-0.168 l 0,-10.514 c 0,-2.912 1.204,-4.254 4.519,-4.254 l 1.842,0 c 0.101,0 0.168,0.068 0.168,0.17 l 0,1.673 c 0,0.101 -0.067,0.167 -0.168,0.167 l -1.807,0 c -1.441,0 -2.211,0.503 -2.211,2.244 l 0,10.514 c 0,0.102 0.066,0.168 0.168,0.168 l 3.85,0 c 0.101,0 0.168,0.068 0.168,0.168 l 0,1.674 C 0.168,-0.066 0.101,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(175.2787,56.841)",
    id: "g3405"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3407",
    style: {
      fill: "#433965",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 6.941,0 C 7.04,0 7.108,0.066 7.108,0.168 l 0,2.996 c 0,0.1 -0.068,0.166 -0.167,0.166 L 0,3.33 c -0.101,0 -0.168,-0.066 -0.168,-0.166 l 0,-2.996 C -0.168,0.066 -0.101,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(167.9346,55.791)",
    id: "g3409"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3411",
    style: {
      fill: "#433965",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 -3.751,0 C -3.85,0 -3.919,-0.101 -3.952,-0.201 l -2.679,-12.926 c -0.033,-0.167 -0.302,-0.167 -0.335,0 l -3.08,12.926 C -10.079,-0.101 -10.181,0 -10.28,0 l -5.36,0 c -0.099,0 -0.2,-0.101 -0.233,-0.201 l -3.081,-12.926 c -0.033,-0.2 -0.302,-0.2 -0.335,0 l -2.679,12.926 C -22.001,-0.101 -22.1,0 -22.202,0 l -3.751,0 c -0.099,0 -0.167,-0.066 -0.134,-0.201 l 3.885,-16.575 c 0.033,-0.102 0.102,-0.168 0.201,-0.168 l 5.726,0 c 0.101,0 0.168,0.066 0.201,0.168 l 2.947,12.959 c 0.034,0.201 0.301,0.201 0.336,0 l 2.946,-12.959 c 0.033,-0.102 0.101,-0.168 0.2,-0.168 l 5.726,0 c 0.102,0 0.168,0.066 0.203,0.168 L 0.168,-0.201 C 0.201,-0.066 0.101,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(216.1326,49.4287)",
    id: "g3413"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3415",
    style: {
      fill: "#433965",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -1.54,0.201 -2.981,0.402 -2.981,1.474 0,0.871 0.971,1.54 2.981,1.54 2.445,0 3.281,-1.273 3.281,-2.211 0,-0.099 0.068,-0.167 0.168,-0.167 l 3.751,0 c 0.101,0 0.132,0.068 0.132,0.167 C 7.301,4.689 4.254,6.697 0,6.697 c -4.186,0 -6.999,-2.344 -6.999,-5.223 0,-4.219 3.886,-4.823 7.334,-5.19 1.373,-0.134 3.416,-0.134 3.416,-1.608 0,-1.642 -2.01,-1.909 -3.416,-1.909 -2.411,0 -3.448,1.139 -3.448,2.211 0,0.099 -0.069,0.166 -0.168,0.166 l -3.853,0 c -0.099,0 -0.167,-0.067 -0.167,-0.166 0,-3.014 2.645,-5.896 7.636,-5.896 4.555,0 7.434,2.01 7.434,5.594 C 7.769,-0.569 2.948,-0.368 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(236.9002,55.791)",
    id: "g3417"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3419",
    style: {
      fill: "#433965",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 -3.416,0 c -0.099,0 -0.167,0.066 -0.167,0.168 l 0,4.045 c 0,0.101 -0.067,0.168 -0.168,0.168 l -3.683,0 c -0.101,0 -0.167,-0.067 -0.167,-0.168 l 0,-4.045 C -7.601,0.066 -7.67,0 -7.769,0 l -2.745,0 c -0.101,0 -0.168,-0.066 -0.168,-0.168 l 0,-3.181 c 0,-0.1 0.067,-0.166 0.168,-0.166 l 2.745,0 c 0.099,0 0.168,-0.068 0.168,-0.17 l 0,-8.539 c 0,-3.347 1.473,-4.72 4.989,-4.72 l 2.612,0 c 0.101,0 0.168,0.066 0.168,0.168 l 0,3.347 c 0,0.102 -0.067,0.168 -0.168,0.168 l -2.377,0 c -0.67,0 -1.206,0.404 -1.206,1.072 l 0,8.504 c 0,0.102 0.068,0.17 0.167,0.17 l 3.416,0 c 0.101,0 0.168,0.066 0.168,0.166 l 0,3.181 C 0.168,-0.066 0.101,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(201.34,49.1269)",
    id: "g3421"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3423",
    style: {
      fill: "#433965",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 -7.601,0 c -0.102,0 -0.135,0.033 -0.135,0.135 0,1.306 1.273,3.179 3.985,3.179 2.745,0 3.886,-1.84 3.886,-3.179 C 0.135,0.033 0.099,0 0,0 m -3.751,6.999 c -4.89,0 -8.171,-3.55 -8.171,-8.806 0,-5.225 3.281,-8.808 8.171,-8.808 3.817,0 6.864,1.943 7.601,5.191 0.034,0.1 -0.066,0.168 -0.165,0.168 l -3.919,0 c -0.168,0 -0.234,-0.101 -0.269,-0.168 -0.569,-1.14 -1.774,-1.509 -3.248,-1.509 -2.377,0 -3.985,1.576 -3.985,3.418 0,0.099 0.068,0.168 0.168,0.168 l 11.652,0 c 0.102,0 0.135,0.066 0.168,0.165 0.101,0.402 0.135,0.704 0.168,1.375 0,5.223 -3.281,8.806 -8.171,8.806"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120.0962,81.5192)",
    id: "g3425"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3427",
    style: {
      fill: "#433965",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 16.065,-4.606 2.602,-49.303 -13.421,-44.697 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(106.6753,36.8221)",
    id: "g3429"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3431",
    style: {
      fill: "#ea554b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 -11.26,37.648 4.732,33.034 16.023,-4.606 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(82.1261,43.8855)",
    id: "g3433"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3435",
    style: {
      fill: "#c6b5a8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 -11.26,37.648 4.732,33.034 16.023,-4.606 0,0 Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWupLogo);
export default __webpack_public_path__ + "static/media/wup_logo.30b458f7.svg";
export { ForwardRef as ReactComponent };